import React from 'react';
import styles from './popularideas.module.scss';
import { Row, Col } from 'react-bootstrap';

function PopularIdeas({ ideas, goToIdea }) {
	if (!ideas || ideas.length === 0) {
		return null;
	}

	const decodeText = (text) => {
		if (!text) return '';
		try {
			return decodeURIComponent(text);
		} catch {
			return text;
		}
	};

	return (
		<div className={styles.section_wrapper}>
			<div className={styles.section_header}>
				<h2 className={styles.title}>Focused IP</h2>
			</div>
			<Row xs={1} sm={2} lg={4} className="g-3">
				{ideas.map((item) => (
					<Col key={item.id}>
						<div className={styles.card} onClick={() => goToIdea(item.cid, item.id)} data-test={`popular-idea-card-${item.id}`}>
							<div className={styles.card_image_wrap}>
								<img className={styles.card_image} src={item.featured_image} alt="Popular idea" />
							</div>
							<div className={styles.card_content}>
								<div className={styles.card_title}>{decodeText(item.title)}</div>
								<p className={styles.card_description}>{decodeText(item.description)}</p>
							</div>
						</div>
					</Col>
				))}
			</Row>
		</div>
	);
}

export default PopularIdeas;
